import { useTranslate } from '@i18n';
import { Stack, Text, u, Box } from '@ui';

import * as css from './WizardProgress.css';

type WizardProgressType = {
    title: string;
    subHeader?: string;
    progressLabel?: string;
    totalSteps: number;
    currentStep: number;
};

export const WizardProgress = ({ title, subHeader, totalSteps, currentStep }: WizardProgressType) => {
    const t = useTranslate();
    const clampedProgress = totalSteps ? (currentStep / totalSteps) * 100 : 0;

    const progressLabel = totalSteps
        ? `${t('activity_wizard.step')} ${currentStep} ${t('activity_wizard.of')} ${totalSteps}`
        : undefined;
    return (
        <Stack p={u(2.5)}>
            <Box display="flex" justifyContent="space-between" alignItems="center" gap={u(2)}>
                <Text variant="pSmall">{title}</Text>
                <Text variant="pSmall">{progressLabel}</Text>
            </Box>
            <div className={css.progressTrack} aria-hidden>
                <div className={css.progressFill} style={{ width: `${clampedProgress}%` }} />
            </div>
            <Text variant="pSmall" className={css.subHeader}>
                {subHeader}
            </Text>
        </Stack>
    );
};
